import {useCallback, useState} from "react";
import type {MapAnnotation} from "./MapAnnotation.ts";

export type MapFeatureSelection =
    | {type: "annotation"; levelId: string; source: MapAnnotation["source"]; id: string}
    | {type: "door"; levelId: string; id: string}
    | {type: "light"; levelId: string; id: string};

export default function useMapFeatureSelection() {
    const [selection, setSelection] = useState<MapFeatureSelection>();
    const clear = useCallback(() => setSelection(undefined), []);
    const selectAnnotation = useCallback((levelId: string, item: MapAnnotation) => {
        setSelection({type: "annotation", levelId, source: item.source, id: item.annotation.id});
    }, []);
    const selectDoor = useCallback((levelId: string, id: string) => {
        setSelection({type: "door", levelId, id});
    }, []);

    const selectLight = useCallback((levelId: string, id: string) => {
        setSelection({type: "light", levelId, id});
    }, []);

    return {selection, clear, selectAnnotation, selectDoor, selectLight};
}

export type MapFeatureSelectionController = ReturnType<typeof useMapFeatureSelection>;
